import axios from "../../../axios";

export const state = {
    items: [],
    item: null,
    fetchQueryParams: {
        current_page: 1,
        search: '',
        per_page: 10,
        sort_field: 'id',
        sort_desc: true
    },
    isFetched: false
}

export const mutations = {
    SET_APPLICATIONS(state, applications) {
        state.items = applications
    },
    SET_FETCH_QUERY_PARAMS(state, params) {
        state.fetchQueryParams = params
    },
    SET_APPLICATIONS_IS_FETCHED(state, isFetched) {
        state.isFetched = isFetched
    }
}

export const actions = {
    fetchData({commit, state}, params) {
        return new Promise((resolve, reject) => {
            const defaultParams = {
                search: state.fetchQueryParams.search,
                page: state.fetchQueryParams.current_page,
                size: state.fetchQueryParams.per_page,
                'order_key': state.fetchQueryParams.sort_field,
                'order_by': state.fetchQueryParams.sort_desc ? 'desc' : 'asc'
            }

            if (params && typeof params === 'object') {
                console.log(params)
            }

            if (!state.isFetched) {
                axios.get('applications', {params: defaultParams})
                    .then((res) => {
                        commit('SET_APPLICATIONS_IS_FETCHED', true)
                        commit('SET_APPLICATIONS',  res.data.data)
                        resolve(res)
                    })
                    .catch((er) => {
                        reject(er)
                    })
            } else {
                resolve()
            }
        })
    },
    setFetchQueryParams({commit}, data) {
        commit('SET_PAGINATION_DATA', data)
    }
}
